import PropTypes from "prop-types";
import Radio from "theme/components/inputs/Radio";
import React from "react";

const SortRadio = ({ name, id, value, checked, onChange, children }) => {
    return (
        <Radio alignText="before" id={id} name={name} value={value} isChecked={checked} onChange={onChange}>
            {children}
        </Radio>
    );
};

SortRadio.propTypes = {
    checked: PropTypes.bool.isRequired,
    children: PropTypes.node,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

SortRadio.defaultProps = {
    children: null,
};

export default SortRadio;
